/* ==========================================================================
   Blessed Bangles — bb-cart.js
   ONE cart function for the whole theme. Every add-to-cart on every surface
   (PDP tiers, featured cards, bundle, cart cross-sells) goes through
   BB.cart.add(). It posts to /cart/add.js, refreshes the drawer from
   /cart.js, opens the drawer, restores the button and shows "Added".
   Prices are always written with innerHTML (money format may contain markup).
   ========================================================================== */
(function () {
  'use strict';
  var BB = (window.BB = window.BB || {});
  var cfg = window.BBConfig || {};

  /* ---------- money ---------- */
  BB.money = function (cents, withCurrency) {
    var fmt = (withCurrency ? cfg.moneyWithCurrencyFormat : cfg.moneyFormat) || '${{amount}}';
    var n = Math.round(Number(cents) || 0);
    var neg = n < 0; n = Math.abs(n);
    var whole = Math.floor(n / 100), frac = ('0' + (n % 100)).slice(-2);
    var wholeStr = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var glued = /\{\{\s*amount\s*\}\}\d/.test(fmt);   /* KWD "{{amount}}0 KD": the 3rd decimal is in the format, so keep ".00" (10.000 KD, never 100 KD) */
    var out = fmt
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, wholeStr)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + frac)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, wholeStr)
      .replace(/\{\{\s*amount\s*\}\}/g, frac === '00' && !glued ? wholeStr : wholeStr + '.' + frac);   /* same as Liquid's money */
    return (neg ? '-' : '') + out;
  };

  /* ---------- tiny helpers ---------- */
  BB.qs = function (s, r) { return (r || document).querySelector(s); };
  BB.qsa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  BB.on = function (el, ev, fn) { if (el) el.addEventListener(ev, fn); };
  BB.escape = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  BB.emit = function (name, detail) { document.dispatchEvent(new CustomEvent(name, { detail: detail || {} })); };
  BB.track = function (name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {}
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, data || {})); } catch (e) {}
  };

  /* ---------- toast ---------- */
  var toastEl, toastT;
  BB.toast = function (msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'bb-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2400);
  };

  /* ---------- button state ---------- */
  function setLoading(btn, on) {
    if (!btn) return;
    if (on) { btn.dataset.bbLabel = btn.innerHTML; btn.classList.add('is-loading'); btn.disabled = true; }
    else { btn.classList.remove('is-loading'); btn.disabled = false; if (btn.dataset.bbLabel) btn.innerHTML = btn.dataset.bbLabel; }
  }
  function flashAdded(btn, text) {
    if (!btn) return;
    var orig = btn.dataset.bbLabel || btn.innerHTML;
    btn.innerHTML = '<span class="btn__label">' + BB.escape(text || cfg.addedLabel || 'Added ✓') + '</span>';
    btn.disabled = false;
    setTimeout(function () { btn.innerHTML = orig; btn.disabled = false; btn.classList.remove('is-loading'); }, 1600);
  }

  /* ---------- cart state ---------- */
  var cart = { state: null, listeners: [], busy: 0 };
  BB.cart = cart;

  cart.fetch = function () {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart.state = c; cart.render(); return c; });
  };

  /**
   * BB.cart.add(items, opts)
   * items: [{id, quantity, properties?}]  OR a FormData (for file uploads)
   * opts:  {button, open=true, label}
   */
  cart.add = function (items, opts) {
    opts = opts || {};
    var btn = opts.button; setLoading(btn, true);
    var req; cart.busy++;
    if (items instanceof FormData) {
      req = fetch('/cart/add.js', { method: 'POST', body: items, credentials: 'same-origin' });
    } else {
      var list = Array.isArray(items) ? items : [items];
      list = list.filter(function (i) { return i && i.id && (i.quantity || 1) > 0; }).map(function (i) { return { id: Number(i.id), quantity: Number(i.quantity || 1), properties: i.properties || undefined }; });
      req = fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: list }) });
    }
    req.then(function () { setTimeout(function () { cart.busy = Math.max(0, cart.busy - 1); }, 400); }, function () { cart.busy = Math.max(0, cart.busy - 1); });
    return req.then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); })
      .then(function (added) {
        BB.track('bb_add_to_cart', { items: Array.isArray(items) ? items : [], source: opts.source || 'unknown' });
        return cart.fetch().then(function () {
          setLoading(btn, false); flashAdded(btn, opts.label);
          if (opts.open !== false && cfg.cartDrawer !== false) cart.open();
          BB.toast(cfg.addedToast || 'Added to your bag');
          BB.emit('bb:cart:added', { added: added });
          return added;
        });
      })
      .catch(function (err) {
        setLoading(btn, false); if (btn) btn.disabled = false;
        BB.toast(err.message || 'Something went wrong');
        throw err;
      });
  };

  cart.change = function (key, quantity) {
    return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: quantity }) })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart.state = c; cart.render(); return c; });
  };

  cart.update = function (payload) {
    return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json(); }).then(function (c) { cart.state = c; cart.render(); return c; });
  };

  /* ---------- drawer ---------- */
  var drawer, overlay;
  function els() { drawer = drawer || BB.qs('#bb-cart-drawer'); overlay = overlay || BB.qs('#bb-overlay'); }
  cart.open = function () { els(); if (!drawer) return; drawer.classList.add('is-open'); overlay && overlay.classList.add('is-open'); document.body.classList.add('bb-lock'); drawer.setAttribute('aria-hidden', 'false'); BB.emit('bb:drawer:open', { id: 'cart' }); };
  cart.close = function () { els(); if (!drawer) return; drawer.classList.remove('is-open'); overlay && overlay.classList.remove('is-open'); document.body.classList.remove('bb-lock'); drawer.setAttribute('aria-hidden', 'true'); };

  cart.render = function () {
    els(); var c = cart.state; if (!c) return;
    BB.qsa('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.setAttribute('data-count', c.item_count); });
    if (!drawer) return;
    var body = BB.qs('[data-cart-items]', drawer), empty = BB.qs('[data-cart-empty]', drawer), foot = BB.qs('[data-cart-foot]', drawer);
    if (!body) return;
    if (!c.items.length) { body.innerHTML = ''; if (empty) empty.hidden = false; if (foot) foot.hidden = true; }
    else {
      if (empty) empty.hidden = true; if (foot) foot.hidden = false;
      /* lineDiscounts off: lines at their regular price, the saving once above the total (always adds up) */
      var lineDisc = cfg.lineDiscounts !== false;
      body.innerHTML = c.items.map(function (it) {
        var props = Object.keys(it.properties || {}).filter(function (k) { return k.charAt(0) !== '_' && it.properties[k]; }).map(function (k) { return '<div class="cartd__prop">' + BB.escape(k) + ': ' + BB.escape(String(it.properties[k]).replace(/^https?:\/\/\S+$/, 'uploaded')) + '</div>'; }).join('');
        var linePrice = lineDisc ? it.final_line_price : it.original_line_price, orig = it.original_line_price;
        return '<li class="cartd__item" data-key="' + it.key + '">' +
          '<img class="cartd__img" src="' + (it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_150x150$1$2') : '') + '" alt="" loading="lazy">' +
          '<div><div class="cartd__name">' + BB.escape(it.product_title) + '</div>' +
          (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="cartd__var">' + BB.escape(it.variant_title) + '</div>' : '') + props +
          '<div class="cartd__qty"><button type="button" data-qty="-1" aria-label="Decrease">−</button><span>' + it.quantity + '</span><button type="button" data-qty="1" aria-label="Increase">+</button></div>' +
          '<button type="button" class="cartd__remove" data-remove>' + BB.escape(cfg.removeLabel || 'Remove') + '</button></div>' +
          '<div class="cartd__price">' + (linePrice < orig ? '<s>' + BB.money(orig) + '</s>' : '') + (linePrice === 0 ? '<span class="bb-save">' + BB.escape(cfg.freeLabel || 'FREE') + '</span>' : BB.money(linePrice)) + '</div></li>';
      }).join('');
    }
    var sub = BB.qs('[data-cart-subtotal]', drawer); if (sub) sub.innerHTML = BB.money(c.items_subtotal_price);
    var disc = BB.qs('[data-cart-discount]', drawer);
    if (disc) { var d = cfg.lineDiscounts !== false ? (c.total_discount || 0) : Math.max(0, (c.original_total_price || 0) - c.total_price); disc.hidden = d <= 0; var dv = BB.qs('[data-cart-discount-value]', drawer); if (dv) dv.innerHTML = '−' + BB.money(d); }
    var tot = BB.qs('[data-cart-total]', drawer); if (tot) tot.innerHTML = BB.money(c.total_price);
    /* progress bar */
    var prog = BB.qs('[data-cart-progress]', drawer);
    if (prog) {
      var th = Number(prog.dataset.threshold || 0);
      var remaining = th - c.total_price;
      var pct = th > 0 ? Math.min(100, Math.round((c.total_price / th) * 100)) : 100;
      var txt = BB.qs('[data-progress-text]', prog), bar = BB.qs('[data-progress-bar]', prog);
      if (bar) bar.style.width = pct + '%';
      if (txt) txt.innerHTML = remaining > 0 ? (prog.dataset.textRemaining || 'Add [amount] more for free delivery').replace(/\[amount\]|\{\{\s*amount\s*\}\}/g, '<b>' + BB.money(remaining) + '</b>') : (prog.dataset.textDone || 'Free delivery unlocked ✓');
      prog.classList.toggle('is-done', remaining <= 0);
    }
    /* cross-sell: hide items already in cart; when an offer already includes a free gift box, the gift-box
       suggestion is worded as an extra one (so nobody pays for a box they think is missing) */
    var giftProp = cfg.giftIncludedProp || 'Gift box';
    var boxIncluded = c.items.some(function (it) { return !!(it.properties && it.properties[giftProp]); });
    BB.qsa('[data-crosssell-chip]', drawer).forEach(function (chip) {
      var pid = Number(chip.dataset.productId);
      chip.hidden = c.items.some(function (it) { return it.product_id === pid; });
      if (chip.hasAttribute('data-gift-chip')) {
        var tt = BB.qs('[data-chip-title]', chip);
        if (tt) { if (!tt.dataset.orig) tt.dataset.orig = tt.textContent; var want = boxIncluded ? (chip.dataset.extraLabel || 'Add an extra gift box') : tt.dataset.orig; if (tt.textContent !== want) tt.textContent = want; }
      }
    });
    BB.emit('bb:cart:render', { cart: c });
  };

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cart-open]'); if (t) { e.preventDefault(); cart.open(); return; }
    t = e.target.closest('[data-cart-close]'); if (t) { e.preventDefault(); cart.close(); return; }
    t = e.target.closest('[data-qty]'); if (t && t.closest('#bb-cart-drawer')) { var li = t.closest('[data-key]'); var it = cart.state.items.find(function (i) { return i.key === li.dataset.key; }); if (it) cart.change(it.key, Math.max(0, it.quantity + Number(t.dataset.qty))); return; }
    t = e.target.closest('[data-remove]'); if (t && t.closest('#bb-cart-drawer')) { var li2 = t.closest('[data-key]'); cart.change(li2.dataset.key, 0); return; }
    t = e.target.closest('[data-add-variant]');
    if (t) { e.preventDefault(); cart.add([{ id: t.dataset.addVariant, quantity: Number(t.dataset.qty || 1) }], { button: t, source: t.dataset.source || 'card' }); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cart.close(); });
  BB.on(BB.qs('#bb-overlay'), 'click', function () { cart.close(); BB.emit('bb:overlay:click'); });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-cart-note]')) cart.update({ note: e.target.value });
  });

  /* restore any button left disabled by bfcache */
  window.addEventListener('pageshow', function () { BB.qsa('.btn[disabled], .btn.is-loading').forEach(function (b) { b.disabled = false; b.classList.remove('is-loading'); if (b.dataset.bbLabel) b.innerHTML = b.dataset.bbLabel; }); });

  /* ---------- adds made by apps or the native form: show our drawer ---------- */
  var ADD = /\/cart\/add(\.js)?(\?|$)/;
  function afterForeignAdd() { if (cart.busy) return; cart.fetch().then(function () { if (cfg.cartDrawer !== false) cart.open(); }); }
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (u) {
      var p = _fetch.apply(this, arguments);
      try { if (ADD.test(String(u && u.url || u)) && !cart.busy) p.then(function (r) { if (r && r.ok) setTimeout(afterForeignAdd, 60); }); } catch (e) {}
      return p;
    };
  }
  var _open = XMLHttpRequest.prototype.open, _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__bbAdd = ADD.test(String(u)); return _open.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (this.__bbAdd && !cart.busy) this.addEventListener('load', function () { if (this.status < 400) setTimeout(afterForeignAdd, 60); });
    return _send.apply(this, arguments);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cart.fetch); else cart.fetch();
})();
